import React from "react";
import NFLookupEmptyForms from "../../../Shared/NewForms/NFLookupEmptyForms";

function EmployeeHiresGenericSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default EmployeeHiresGenericSkeleton;
